import { EMAIL_STORAGE } from './storageConfig'

export function storageEmailSave (email: string) {
  localStorage.setItem(EMAIL_STORAGE, email)
}

export function storageEmailGet () {
  return localStorage.getItem(EMAIL_STORAGE)
}
